import { Box, Typography } from '@mui/material';

const NotFound = () => {
  return (
    <Box sx={{ pt: 16, textAlign: 'center' }}>
      <Typography variant="notFoundTitle" sx={{ mb: 2, color: 'primary.main' }}>
        404
      </Typography>
      <Typography variant="h2" color="text.primary">
        Not found
      </Typography>
    </Box>
  );
};

export default NotFound;
